import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Lobby from "./pages/Lobby";
import Blackjack from "./pages/Blackjack";
import Roulette from "./pages/Roulette";
import Slots from "./pages/Slots";
import SlotsCatalog from "./pages/SlotsCatalog";
import Casinos from "./pages/Casinos";
import LiveCasino from "./pages/LiveCasino";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import ResponsibleGambling from "./pages/ResponsibleGambling";
import Referrals from "./pages/Referrals";
import Cashier from "./pages/Cashier";
import PaymentReturn from "./pages/PaymentReturn";
import SportsBetting from "./pages/SportsBetting";
import DailyWheel from "./pages/DailyWheel";
import Leaderboard from "./pages/Leaderboard";
import Tournaments from "./pages/Tournaments";
import Subscribe from "./pages/Subscribe";
import AdminDashboard from "./pages/AdminDashboard";
import InstantLobby from "./pages/InstantLobby";
import Crash from "./pages/Crash";
import Mines from "./pages/Mines";
import Dice from "./pages/Dice";
import Limbo from "./pages/Limbo";
import Plinko from "./pages/Plinko";
import DragonTower from "./pages/DragonTower";
import KYC from "./pages/KYC";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import "./App.css";

function AppRouter() {
  const loc = useLocation();
  if (loc.hash?.includes("session_id=")) return <AuthCallback/>;
  return (
    <Routes>
      <Route path="/" element={<Layout><Landing/></Layout>}/>
      <Route path="/login" element={<Layout><Login/></Layout>}/>
      <Route path="/register" element={<Layout><Register/></Layout>}/>
      <Route path="/dashboard" element={<ProtectedRoute><Layout><Lobby/></Layout></ProtectedRoute>}/>
      <Route path="/lobby" element={<ProtectedRoute><Layout><Lobby/></Layout></ProtectedRoute>}/>
      <Route path="/blackjack" element={<ProtectedRoute><Layout><Blackjack/></Layout></ProtectedRoute>}/>
      <Route path="/roulette" element={<ProtectedRoute><Layout><Roulette/></Layout></ProtectedRoute>}/>
      <Route path="/slots" element={<ProtectedRoute><Layout><SlotsCatalog/></Layout></ProtectedRoute>}/>
      <Route path="/slots/play/:slot_id" element={<ProtectedRoute><Layout><Slots/></Layout></ProtectedRoute>}/>
      <Route path="/casinos" element={<Layout><Casinos/></Layout>}/>
      <Route path="/live-casino" element={<Layout><LiveCasino/></Layout>}/>
      <Route path="/terms" element={<Layout><Terms/></Layout>}/>
      <Route path="/privacy" element={<Layout><Privacy/></Layout>}/>
      <Route path="/responsible" element={<Layout><ResponsibleGambling/></Layout>}/>
      <Route path="/referrals" element={<ProtectedRoute><Layout><Referrals/></Layout></ProtectedRoute>}/>
      <Route path="/instant" element={<ProtectedRoute><Layout><InstantLobby/></Layout></ProtectedRoute>}/>
      <Route path="/instant/crash" element={<ProtectedRoute><Layout><Crash/></Layout></ProtectedRoute>}/>
      <Route path="/instant/mines" element={<ProtectedRoute><Layout><Mines/></Layout></ProtectedRoute>}/>
      <Route path="/instant/dice" element={<ProtectedRoute><Layout><Dice/></Layout></ProtectedRoute>}/>
      <Route path="/instant/limbo" element={<ProtectedRoute><Layout><Limbo/></Layout></ProtectedRoute>}/>
      <Route path="/instant/plinko" element={<ProtectedRoute><Layout><Plinko/></Layout></ProtectedRoute>}/>
      <Route path="/instant/dragon" element={<ProtectedRoute><Layout><DragonTower/></Layout></ProtectedRoute>}/>
      <Route path="/kyc" element={<ProtectedRoute><Layout><KYC/></Layout></ProtectedRoute>}/>
      <Route path="/sports" element={<ProtectedRoute><Layout><SportsBetting/></Layout></ProtectedRoute>}/>
      <Route path="/wheel" element={<ProtectedRoute><Layout><DailyWheel/></Layout></ProtectedRoute>}/>
      <Route path="/leaderboard" element={<ProtectedRoute><Layout><Leaderboard/></Layout></ProtectedRoute>}/>
      <Route path="/tournaments" element={<ProtectedRoute><Layout><Tournaments/></Layout></ProtectedRoute>}/>
      <Route path="/subscribe" element={<ProtectedRoute><Layout><Subscribe/></Layout></ProtectedRoute>}/>
      <Route path="/subscribe/return" element={<ProtectedRoute><Layout><Subscribe/></Layout></ProtectedRoute>}/>
      <Route path="/admin" element={<ProtectedRoute><Layout><AdminDashboard/></Layout></ProtectedRoute>}/>
      <Route path="/admin/sports" element={<ProtectedRoute><Layout><AdminDashboard/></Layout></ProtectedRoute>}/>
      <Route path="/cashier" element={<ProtectedRoute><Layout><Cashier/></Layout></ProtectedRoute>}/>
      <Route path="/payment/return" element={<ProtectedRoute><Layout><PaymentReturn/></Layout></ProtectedRoute>}/>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <AppRouter/>
          <Toaster theme="dark" position="top-right" richColors/>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}
